import type { VersionChange } from '@shared/types/versioned-entity.types'

export function generateVersionDescription(changes: VersionChange[]): string {
  if (changes.length === 0) return 'Initial version'

  const added = changes.filter(c => c.changeType === 'added')
  const modified = changes.filter(c => c.changeType === 'modified')
  const removed = changes.filter(c => c.changeType === 'removed')

  const parts: string[] = []

  if (modified.length === 1) {
    parts.push(`Updated ${modified[0].fieldLabel || modified[0].field}`)
  } else if (modified.length > 1) {
    parts.push(`Updated ${modified.length} fields`)
  }

  if (added.length === 1) {
    parts.push(`Added ${added[0].fieldLabel || added[0].field}`)
  } else if (added.length > 1) {
    parts.push(`Added ${added.length} fields`)
  }

  if (removed.length === 1) {
    parts.push(`Removed ${removed[0].fieldLabel || removed[0].field}`)
  } else if (removed.length > 1) {
    parts.push(`Removed ${removed.length} fields`)
  }

  return parts.join('; ') || `${changes.length} change(s)`
}
